var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-result',{attrs:{"icon":"warning","title":"人機驗證","subTitle":"為了保護您的帳號安全，請完成以下驗證。"}},[_c('template',{slot:"extra"},[_c('div',{attrs:{"id":"turnstile-container"}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }